import { render, staticRenderFns } from "./elecIndustrialPress.vue?vue&type=template&id=4ca72a9b&scoped=true&"
import script from "./elecIndustrialPress.vue?vue&type=script&lang=js&"
export * from "./elecIndustrialPress.vue?vue&type=script&lang=js&"
import style0 from "./elecIndustrialPress.vue?vue&type=style&index=0&id=4ca72a9b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca72a9b",
  null
  
)

export default component.exports